export default "__VITE_ASSET__e14aeac3__"